module.exports = __webpack_public_path__ + "img/diversion_close.ba57a7f9.png";